import { gql } from "@apollo/client"

export const USER_LIST = gql`
  query UserList($UserListInput: UserListInput!) {
    UserList(input: $UserListInput) {
      status {
        success
        name
      }
      total
      pages
      Users {
        id
        name
        firstSurname
        lastSurname
        fullName
        code
        email
        phone
        avatar
        urlAvatar
        emailValid
        documentNumber
        documentNumberType
        active
        urlEdit
        created
        birthday
        PersonCategory {
          name
        }
        Address {
          countryId
          regionId
          locationId
          Location {
            name
          }
        }
      }
    }
  }
`
